require('sass/brands/locations.firstinterstatebank.com/location/default.scss');
require('js/location-script.js');
